import { useState, useEffect } from 'react';

export function getValueFromSession<T>(fallback: T, storageKey: string) {
    try {
        return (JSON.parse(sessionStorage.getItem(storageKey) ?? 'null') as T ?? fallback);
    } catch (e) {
        return fallback;
    }
}

export function writeValueToSession<T>(value: T, storageKey: string) {
    sessionStorage.setItem(storageKey, JSON.stringify(value));
}

export function useSessionStorage<T>(fallbackState: T, storageKey: string): [T, React.Dispatch<React.SetStateAction<T>>] {
    const [value, setValue] = useState(
        getValueFromSession<T>(fallbackState, storageKey)
    );

    useEffect(() => {
        writeValueToSession<T>(value, storageKey);
    }, [value, storageKey]);

    return [value, setValue];
};

export function useUrlSessionStorage() {
    const urlSessionStorageKey: string = 'url';

    const [url, setUrl] = useState(() => {
        return sessionStorage.getItem(urlSessionStorageKey) ?? '';
    });

    useEffect(() => {
        sessionStorage.setItem(urlSessionStorageKey, url);
    }, [url]);

    return { url, setUrl };
}